export default __webpack_public_path__ + "static/main-58638eb0d3e6184b36bc87a7077ccd45.jpg";